module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/t0x818/tc-custom/9781504096621.jpg?1723231327977",
      "alt": "This image is the cover for the book Her Best Friend's Husband"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Her Best Friend's Husband\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A wrenching new novel of guilt, good intentions, and terrifying twists by the acclaimed author of "), _c('i', [_vm._v("Casual Cruelties")]), _vm._v(".")]), _c('br'), _c('br'), _vm._v(" On paper, Claire has it all. A long and happy marriage, two lovely daughters, and a big house in the country. But she’s hiding a secret . . ."), _c('br'), _c('br'), _vm._v(" Struggling with issues from her school days, Claire finds her life beginning to unravel as she seeks comfort in the arms of her best friend’s husband. When she learns of a school reunion, she sees her opportunity to put things right."), _c('br'), _c('br'), _vm._v(" But even the best laid plans can go awry, and not everyone is willing to forgive and forget . . .\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Alison Irving\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("I was born in Northern Ireland and studied physiotherapy at the University of Ulster, where I met my husband in first term of first year. The next fifteen years were spent in England, then Scotland following his job. Eventually we moved home to a small village outside Belfast, where we live with our two children. I still work as a physio in a local hospice and love to explore our fantastic coastline, make jewellery that I sell worldwide, and put the world to rights with my book club. Sometimes we even read books. ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Bloodhound Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0